import { Box, ChakraProvider, extendTheme } from "@chakra-ui/react";

import Hero from "./components/Hero";
import Products from "./components/Products";
import Story from "./components/Story";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Steps from "./components/Steps";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

const theme = extendTheme({
  colors: {
    sedapePinkDark: "#E50F66",
    sedapePink: "#FE3265",
    sedapeGoldDark: "#CE9B40",
    sedapeGold: "#EBBF5C",
    sedapeLight: "#FEDEE2",
  },
  fonts: {
    heading: "'Poppins', sans-serif",
    body: "Poppins, sans-serif",
  },
  styles: {
     global: {
      "html, body": {
        scrollBehavior: "smooth",
        // Scrollbar para navegadores Webkit (Chrome, Edge, Safari)
        "&::-webkit-scrollbar": {
          width: "12px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#FEDEE2",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#FE3265",
          borderRadius: "24px",
          border: "3px solid #FEDEE2",
        },
      },
      // Scrollbar para Firefox
      "*": {
        scrollbarWidth: "thin",
        scrollbarColor: "#FE3265 #FEDEE2",
      },
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Navbar />

      <Box id="hero">
        <Hero />
      </Box>

      <Box id="products">
        <Products />
      </Box>

      <Box id="story">
        <Story />
      </Box>

      <Box id="features">
        <Features />
      </Box>

      <Box id="testimonials">
        <Testimonials />
      </Box>

      <Box id="steps">
        <Steps />
      </Box>

      <Box id="footer">
        <Footer />
      </Box>
    </ChakraProvider>
  );
}
export default App;
